<template>
  <div class="flex">
    <h3 class="sub-title">{{ $t('patient.underlyingDisease') }}</h3>
    <div class="form-check">
      <BaseSquareCheckBox id="diabetes" :item="'diabetes'" @checked="doCheck"/>
      <label class="form-check-label" for="diabetes">
        {{ $t('disease.diabetesMellitus') }}
      </label>
    </div>
    <div class="form-check">
      <BaseSquareCheckBox id="hypertension" :item="'hypertension'" @checked="doCheck"/>
      <label class="form-check-label" for="hypertension">
        {{ $t('disease.hypertension') }}
      </label>
    </div>
    <div class="form-check">
      <BaseSquareCheckBox id="cholesterol" :item="'cholesterol'" @checked="doCheck"/>
      <label class="form-check-label" for="cholesterol">
        {{ $t('disease.highCholesterol') }}
      </label>
    </div>
    <div class="form-check">
      <BaseSquareCheckBox id="smoker" :item="'smoker'" @checked="doCheck"/>
      <label class="form-check-label" for="smoker">
        {{ $t('disease.smoker') }}
      </label>
    </div>
    <div class="form-check">
      <BaseSquareCheckBox id="nwn_underlying" :item="'nwn_underlying'" @checked="doCheck"/>
      <label class="form-check-label" for="nwn_underlying">
        {{ $t('disease.nwn_ophthalmic') }}
      </label>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .flex {
    display:                 flex;
    flex-direction:          column;
    align-items:             flex-start;
    gap:                     15px;
    padding-top:             20px;
  }

  .form-check {
    @include                 border_radius(5px);
    display:                 flex;
    flex-direction:          row;
    justify-content:         center;
    align-items:             center;
    gap:                     10px;
    align-self:              stretch;
    padding:                 0; // 8px 12px;
    // border:                  1px solid var(--Shades-30, #D8D8D8);
    border:                  unset;

    label {
      color:                 var(--Brand-Primary);
      font-size:             13px;
      font-weight:           400;
      line-height:           normal;
      letter-spacing:        1.95px;
      text-transform:        uppercase;
      margin:                0;
    }
  }
</style>

<script>
export default {
  name: 'PatientCreateUnderlyingDiseases',
  props: {
    underlying: { type: Object, default: null },
  },
  data: () => ({
  }),
  mounted() {
    this.$nextTick(() => {
      this.updateCheck()
    })
  },
  methods: {
    updateCheck() {
      for (const [key, value] of Object.entries(this.underlying)) {
        if (value) {
          document.getElementById(key).click()
        }
      }
    },
    doCheck(item) {
      for (const key of Object.keys(this.underlying)) {
        if (key == item.value) {
          this.underlying[key] = item.checked // eslint-disable-line vue/no-mutating-props
        }
      }
    }
  }
}
</script>
